import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";
import FirstAccessAndRecoveryPassword from "../Entitlement/FirstAccessAndRecoveryPassword/FirstAccessAndRecoveryPassword";
import Login from "../Entitlement/Login/Login";
import RequestRecoverPassword from "../Entitlement/RequestRecoverPassword/RequestRecoverPassword";
import UserRoutes from "./Users/Users.routes";

function RoutesApp() {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/request-recover-password"
        element={<RequestRecoverPassword />}
      />
      <Route
        path="/first-access"
        element={<FirstAccessAndRecoveryPassword />}
      />
      <Route
        path="/recovery-password"
        element={<FirstAccessAndRecoveryPassword />}
      />

      <Route path="users/*" element={<UserRoutes />} />

      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
}

export default RoutesApp;
